module.exports = __webpack_public_path__ + "img/pes_t_back.7d429369.jpg";